import React from 'react';
import { ModalProps } from '../../../../components/Modal';
import { Button } from '../../../../components';
import ContainerModal from '../../../../components/ContainerModal';

import { Container } from './styles';
import { useAnalytics } from '../../../../hooks/useAnalytics';
import { FirebaseEvents } from '../../../../utils/enums/firebase-events';
import { useServiceContext } from '../../../../contexts/ServiceContext';
import { useScheduleContext } from '../../../../contexts/ScheduleContext';
import { useRouter } from '../../../../contexts/RouterContext';
import { PAGES } from '../../../General/router/pages';
import { useSpecialistContext } from '../../../../contexts/SpecialistContext';

type ModalScheduleFailProps = Pick<ModalProps, 'visible' | 'onClose'>;

interface ComponentProps extends ModalScheduleFailProps {
  onPressFirstButton: () => void;
}

const warningIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/warning.svg';

const ModalScheduleFail: React.FC<ComponentProps> = ({ onClose, visible, onPressFirstButton }) => {
  const { logEvent } = useAnalytics();
  const { route } = useRouter();

  const { selectedItem, scheduleSpecialistSelected } = useScheduleContext();
  const { selectedService } = useServiceContext();
  const { selectedSpecialist } = useSpecialistContext();

  React.useEffect(() => {
    if (visible)
      logEvent({
        eventName: FirebaseEvents.schedule_unavailable_service,
        eventParams: {
          product_id: selectedItem?.productId,
          product_name: selectedItem?.productName,
          service_id: selectedService.id,
          service_name: selectedService.name,
          screen: PAGES[route]?.title
        }
      });
  }, [visible]);

  return (
    <ContainerModal
      visible={visible}
      onClose={onClose}
      withoutCloseButton={true}
      childrenFooter={
        <>
          <Button title="Agendar novamente" onClick={onPressFirstButton} />
          <Button
            title="Falar com o suporte"
            tertiary
            onClick={() => {
              logEvent({
                eventName: FirebaseEvents.schedule_redirect_call_center,
                eventParams: {
                  service_id: selectedService.id,
                  service_name: selectedService.name,
                  product_name: selectedSpecialist?.name,
                  product_id: selectedSpecialist?.id,
                  unit_id: scheduleSpecialistSelected?.unit?.catalogId,
                  unit_name: scheduleSpecialistSelected?.unit?.name,
                  attendanceType: scheduleSpecialistSelected?.attendanceType,
                  phone: '55112151709'
                }
              });

              window.open('tel:+55112151709');
            }}
          />
        </>
      }
    >
      <Container>
        <img src={warningIcon} alt="warning" />
        <h3>Não foi possível realizar o seu agendamento</h3>

        <div>
          <p>Isso pode ter ocorrido porque:</p>
          <ul>
            <li> - O horário selecionado não está disponível</li>
            <li> - O sistema está indisponível no momento </li>
          </ul>
        </div>

        <p className="info">Tente escolher outro horário ou fale com a nossa central de atendimento.</p>
      </Container>
    </ContainerModal>
  );
};

export default ModalScheduleFail;
